import React from 'react';
import { auth } from '../../../shared/auth/auth';
import NotFound from '../../routes/NotFound/NotFound';

export const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const profile = auth.getUserProfile();
    return (
        <div className="Admin">
            {profile && profile.isAdmin ? children : <NotFound />}
        </div>
    );
};

export const UserRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="User">
        {children}
    </div>
);
